<template>
  <div >
    <div
      class="pl-2"
    >
      {{ $t('Time Period') }}
    </div>
    <date-range-picker
      v-model="dateRange"
      :max-date="dateLimit"
      :auto-apply="true"
      :ranges="false"
      class="rounded"
      @update="refreshDateFilter()"
    />
  </div>
</template>

<script>
import { actionNames } from '@/store'
import dateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'

export default {
  name: 'DateFilter',
  components: {
    dateRangePicker
  },
  data () {
    return {
      dateRange: {
        startDate: '',
        endDate: ''
      },
      dateLimit: ''
    }
  },
  mounted () {
    this.dateRange.startDate = moment().subtract(30, 'days').format('MM-DD-YYYY')
    this.dateRange.endDate = moment().format('MM-DD-YYYY')
    this.dateLimit = moment().format('MM-DD-YYYY')
  },
  methods: {
    refreshDateFilter () {
      this.$store.commit('setDateInterval', this.dateRange)
      this.$store.dispatch(actionNames.INIT_OVERVIEW)
    }
  }
}
</script>
<style scoped>
    ::v-deep .daterangepicker {
        position: fixed;
        left: 380px !important;
    }
</style>
